import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTheme } from "@mui/material/styles";
import { IconButton } from "@mui/material";
import moment from "moment";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

const AnnouncementAdsDialog = ({ announcementData, open, setOpen }) => {
  const theme = useTheme();

  const handleClose = () => {
    setOpen(false);
  };
  const announcementText = announcementData?.body;
  const createdAt = moment(announcementData?.createdAt).format("D MMMM YYYY");

  return (
    <div>
      <Dialog
        maxWidth="lg"
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        PaperProps={{
          style: {
            backgroundColor: "#06623b",
            borderRadius: 0,
          },
        }}
      >
        <IconButton
          onClick={handleClose}
          aria-label="delete"
          sx={{
            position: "absolute",
            color: "white",
            right: "2%",
            top: "3%",
          }}
        >
          <CloseRoundedIcon />
        </IconButton>
        <DialogTitle
          id="responsive-dialog-title"
          sx={{ textAlign: "center", color: "white" }}
          fontSize={{ xs: "14px", md: "18px" }}
        >
          Announcements
        </DialogTitle>
        <DialogContent sx={{ my: "25px" }}>
          <DialogContentText
            sx={{ color: "white", marginBottom: "10px" }}
            fontSize={{ xs: "12px", md: "15px" }}
          >
            {announcementText}
          </DialogContentText>
          <DialogContentText
            sx={{
              color: "white",
              fontWeight: "bold",
              textAlign: "right",
            }}
            fontSize={{ xs: "12px", md: "15px" }}
          >
            {createdAt}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AnnouncementAdsDialog;
